import { render, staticRenderFns } from "./OrderProductPrepare.vue?vue&type=template&id=f48ce9c8&"
import script from "./OrderProductPrepare.vue?vue&type=script&lang=ts&"
export * from "./OrderProductPrepare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports